var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00094 8.16496C4.80594 8.16496 3.83594 7.19496 3.83594 5.99996C3.83594 4.80496 4.80594 3.83496 6.00094 3.83496C7.19594 3.83496 8.16594 4.80496 8.16594 5.99996C8.16594 7.19496 7.19594 8.16496 6.00094 8.16496ZM6.00094 4.58496C5.22094 4.58496 4.58594 5.21996 4.58594 5.99996C4.58594 6.77996 5.22094 7.41496 6.00094 7.41496C6.78094 7.41496 7.41594 6.77996 7.41594 5.99996C7.41594 5.21996 6.78094 4.58496 6.00094 4.58496Z",
    fill: "#fb4646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99906 10.5102C4.11906 10.5102 2.34406 9.41023 1.12406 7.50023C0.594063 6.67523 0.594063 5.33023 1.12406 4.50023C2.34906 2.59023 4.12406 1.49023 5.99906 1.49023C7.87406 1.49023 9.64906 2.59023 10.8691 4.50023C11.3991 5.32523 11.3991 6.67023 10.8691 7.50023C9.64906 9.41023 7.87406 10.5102 5.99906 10.5102ZM5.99906 2.24023C4.38406 2.24023 2.83906 3.21023 1.75906 4.90523C1.38406 5.49023 1.38406 6.51023 1.75906 7.09523C2.83906 8.79023 4.38406 9.76023 5.99906 9.76023C7.61406 9.76023 9.15906 8.79023 10.2391 7.09523C10.6141 6.51023 10.6141 5.49023 10.2391 4.90523C9.15906 3.21023 7.61406 2.24023 5.99906 2.24023Z",
    fill: "#fb4646"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOutline);
export default __webpack_public_path__ + "static/media/eyeOutline.a6fdb577.svg";
export { ForwardRef as ReactComponent };